/* eslint-disable no-case-declarations */
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import PageHeader from '../Header/PageHeader';
import TicketsList from './TicketsList';

const TicketPage = ({ className }) => {
    return (
        <div className={className}>
            <PageHeader title="پرسش‌های ثبت شده" questionCounts />
            <TicketsList perpage={10} />
        </div>
    );
};

TicketPage.propTypes = {
    className: PropTypes.string.isRequired
};

export default styled(TicketPage)`
    position: relative;

    .Loading {
        display: flex;
        align-items: center;
        justify-content: center;
        height: calc(100vh - 240px);
    }
`;
